module.exports = "/static/assets/f6e219646fa4e019a7df8e769d903e57.png";